<template>
  <v-flex>
    <BackToBottomButton ref="bottomButton" />
    <BackToTopButton />
    <v-row no-gutters class="pb-4">
      <v-expansion-panels v-model="panel">
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div>
              <v-icon>filter_list</v-icon>
              <span class="pl-4">Advanced Filters</span>
            </div>
            <div class="d-flex justify-end">
              <v-btn v-if="panel === 0" text @click.stop="resetAdvancedFilters()">
                Reset
              </v-btn>
              <v-btn v-if="panel === 0" text @click.stop="toggleAdvancedOperators()">
                {{ showAdvancedOperators ? 'Hide' : 'Show' }} Operators
              </v-btn>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row>
              <v-col v-for="filter in filterOptions" :key="filter.key" lg="4" md="6" cols="12">
                <div class="d-flex">
                  <div class="body-2 font-weight-bold">
                    {{ filter.text }}
                  </div>
                </div>
                <div class="d-flex align-center" style="max-width: 450px">
                  <v-select v-if="showAdvancedOperators && filter.type !== 'date'" v-model="advancedFieldOperators[filter.key]" dense outlined style="max-width: 150px" :items="getOperators(filter.type)" item-value="key" />
                  <v-text-field v-if="filter.type === 'number'" v-model="advancedFilters[filter.key]" :placeholder="getOperatorTitle(advancedFieldOperators[filter.key])" outlined dense type="number" />
                  <v-text-field v-if="filter.type === 'string'" v-model="advancedFilters[filter.key]" :placeholder="getOperatorTitle(advancedFieldOperators[filter.key])" outlined dense />
                  <v-select v-if="filter.type === 'boolean'" v-model="advancedFilters[filter.key]" :placeholder="getOperatorTitle(advancedFieldOperators[filter.key])" outlined dense :items="[{ text: 'Yes', value: true }, { text: 'No', value: false}, { text: 'Both', value: undefined }]" />
                  <v-select v-if="filter.type === 'enum'" v-model="advancedFilters[filter.key]" :placeholder="getOperatorTitle(advancedFieldOperators[filter.key])" outlined dense :items="filter.options">
                    <template slot="selection" slot-scope="data">
                      {{ filter.display(data.item.value) }}
                    </template>
                    <template slot="item" slot-scope="data">
                      {{ filter.display(data.item.value) }}
                    </template>
                  </v-select>
                  <template v-if="filter.type === 'date'">
                    <v-menu
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="advancedFilters[filter.key + '1']"
                          prepend-icon="event"
                          readonly
                          v-bind="attrs"
                          outlined
                          dense hide-details
                          placeholder="After"
                          v-on="on"
                        />
                      </template>
                      <v-date-picker v-model="advancedFilters[filter.key + '1']" @input="menu2 = false" />
                    </v-menu>
                    <div class="px-2">
                      to
                    </div>
                    <v-menu
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="advancedFilters[filter.key + '2']"
                          prepend-icon="event"
                          readonly
                          v-bind="attrs"
                          outlined
                          dense hide-details
                          placeholder="Before"
                          v-on="on"
                        />
                      </template>
                      <v-date-picker v-model="advancedFilters[filter.key + '2']" @input="menu2 = false" />
                    </v-menu>
                  </template>
                </div>
              </v-col>
            </v-row>
            <v-row justify="end">
              <v-btn class="ma-2" color="primary" @click="applyAdvancedFilters()">
                Apply Filters
              </v-btn>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>
    <v-row v-if="!selected.length" no-gutters class="pb-4" align="center">
      <v-text-field v-model="searchText" label="Search" outlined hide-details single-line class="search-input" @keyup.native.enter="applySearch()" />
      <v-btn color="primary" class="px-6 mx-3" @click.stop="applySearch()">
        Apply
      </v-btn>
      <customise-dialog
        :visible-columns="visibleColumns"
        :available-headers="availableColumns"
        :filter-options="filterOptions"
        :active-filters="activeFilters"
        @addfilter="addFilter($event)"
        @removefilter="removeFilter($event)"
        @newvisible="newVisible($event)"
        @filterstatus="toggleFilter($event)"
      />
      <span class="grey--text text--darken-2 font-italic subheading" :style="{ cursor: 'pointer'}" @click="resetList()">Reset to Default</span>
      <v-spacer />
      <v-btn color="primary" primary @click="exportList()">
        Export
      </v-btn>
      <v-dialog v-model="exportModal" max-width="600">
        <v-card>
          <v-card-title>
            Export Data
          </v-card-title>
          <v-card-text>
            You can either export the data you currently have selected, or all results. The export will follow all applied filters.
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn text color="secondary" @click="download(true)">
              This Page
            </v-btn>
            <v-btn text color="secondary" @click="download(false)">
              All Results
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-divider v-if="!selected.length" class="pb-2" />
    <div v-if="selected.length" style="background-color: rgb(232, 239, 252)">
      <v-row class="justify-space-between">
        <v-col cols="8" class="d-flex align-center">
          <div class="pl-4" style="color: rgb(85, 147, 173); font-size: 16x;">
            {{ selected.length }} item(s) selected
          </div>
        </v-col>
        <v-col cols="4" class="d-flex align-center" style="padding-bottom: 11px;">
          <v-select v-model="selectedBulkAction" dense solo label="Bulk Actions" hide-details :items="bulkActions" item-value="method" />
          <v-btn color="secondary" class="mx-4" @click="doBulkAction()">
            Submit
          </v-btn>
        </v-col>
      </v-row>
    </div>
    <v-row no-gutters class="pb-2">
      <v-chip v-for="(filter, index) in activeFilters" :key="index" close class="white--text" :color=" filter.disabled ? 'primary' : 'secondary' " @click:close="removeFilter(filter)" @click="toggleFilter(filter)">
        {{ filter.text }}
      </v-chip>
    </v-row>
    <v-card v-if="isReady">
      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="listData"
        item-key="userId"
        :server-items-length="total"
        :loading="loading"
        :options.sync="options"
        :footer-props="{
          itemsPerPageOptions: rowsPerPageItems
        }"
        must-sort
        :show-select="showSelect"
      >
        <template v-slot:progress>
          <v-progress-linear indeterminate />
        </template>
        <template v-slot:loading>
          <div class="relative" style="width: 80vw">
            <div class="absolute mx-auto" style="width: 200px;">
              <v-progress-circular color="secondary" indeterminate />
            </div>
          </div>
        </template>
        <template v-slot:item="{ item, isSelected, select }">
          <tr :active="isSelected" :class="{ 'selected-row': isSelected }">
            <td v-if="showSelect">
              <v-checkbox
                :value="isSelected"
                primary
                hide-details
                class="my-auto pa-0"
                @change="select"
              />
            </td>
            <td v-if="actions.length">
              <v-menu bottom right eager>
                <template v-slot:activator="{ on }">
                  <v-btn small icon :disabled="!validActions(item).length" v-on="on" @click.stop>
                    <v-icon>
                      expand_more
                    </v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item v-for="(action, i) in validActions(item)" :key="i" @click="action.method(item)">
                    <v-list-item-title>{{ action.text }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
            <td v-for="column in columns" :key="column.value">
              <template v-if="!column.html">
                {{ renderValue(item, column.value) }}
              </template>
              <span v-if="column.html" v-html="renderValue(item, column.value)" /> <!-- eslint-disable-line -->
              <v-btn v-if="column.action && (!column.action.visible || column.action.visible(item))" small icon class="ml-2" @click.stop="column.action.method(item)">
                <v-icon small>
                  {{ column.action.icon }}
                </v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </v-flex>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import FavouritesManager from '../../modules/favourites'
import customiseDialog from './customise.vue'
import BackToTopButton from '../back-to-top'
import BackToBottomButton from '../back-to-bottom'

export default {
  components: {
    customiseDialog,
    BackToTopButton,
    BackToBottomButton
  },
  props: {
    mode: { type: String, default: 'provider' },
    apiRoute: { type: String, required: true },
    favouritesKey: { type: String, required: true },
    searchField: { type: String, required: true },
    availableColumns: { type: Array, required: true },
    defaultColumns: { type: Array, required: true },
    actions: { type: Array, required: true },
    queryParams: { type: Array, default: () => [] },
    dataExcel: { type: Object, default: () => ({}) },
    exportName: { type: String, required: true },
    showSelect: { type: Boolean, default: false },
    bulkActions: { type: Array, default: () => [] }
  },
  data() {
    return {
      selected: [],
      listData: [],
      total: null,
      loading: false,
      configuring: false,
      isReady: false,
      options: {
        page: 1,
        itemsPerPage: 10
      },
      rowsPerPageItems: [10, 25, 50, 75, 100, 1000, 10000],
      activeFilters: [],
      visibleColumns: [],
      favourites: [],
      activeFavouriteId: null,
      saveFavouriteDialog: false,
      newFavouriteName: null,
      saveFavouriteError: null,
      searchText: '',
      exportModal: false,
      selectedBulkAction: null,
      advancedFilters: {},
      panel: null,
      showAdvancedOperators: false,
      advancedFieldOperators: {}
    }
  },
  computed: {
    filterOptions() {
      return this.availableColumns.map((c) => {
        c.key = c.value
        return c
      })
    },
    headers() {
      let validHeaders = []
      if (this.actions.length) {
        validHeaders.push({ text: 'Actions', value: 'actions', sortable: false })
      }
      
      validHeaders.push(...this.visibleColumns.map((key) => {
        const foundColumn = this.availableColumns.find(h => h.value === key)
        return foundColumn
      }).filter(x => x))
      return validHeaders.map((h) => {
        // h.width = '2rem'
        return h
      })
    },
    columns() {
      return this.headers.filter(h => h.value !== 'actions')
    },
    displayFunctions() {
      const functions = {}
      this.availableColumns.forEach((column) => {
        functions[column.value] = column.display
      })
      return functions
    }
  },
  watch: {
    options: {
      handler() {
        if (this.configuring) {
          this.setSetting()
        }
        if (this.isReady) {
          this.updateResults()
        }
      },
      deep: true
    }
  },
  mounted() {
    this.configureFavourites()
    this.setAdvancedFieldOperators()
  },
  methods: {
    setAdvancedFieldOperators() {
      const operatorObject = {}
      this.filterOptions.forEach((filter) => {
        if (['number', 'enum', 'boolean'].includes(filter.type)) {
          operatorObject[filter.key] = 'eq'
        } else if (filter.type === 'string') {
          operatorObject[filter.key] = 'lk'
        }
      })
      this.advancedFieldOperators = operatorObject
    },
    toggleAdvancedOperators() {
      this.showAdvancedOperators = !this.showAdvancedOperators
    },
    applyAdvancedFilters() {
      this.panel = null
      const newFilters = []
      Object.keys(this.advancedFilters).forEach((key) => {
        const filter = this.filterOptions.find(f => f.key === key)

        if (!filter) {
          let operator
          if (key.endsWith('1')) {
            operator = 'gte'
          } else if (key.endsWith('2')) {
            operator = 'lte'
          } else {
            return
          }

          const field = key.slice(0, key.length - 1)
          const dateFilter = this.filterOptions.find(f => f.key === field)
          const value = this.advancedFilters[key]
          const operatorName = getOperatorTitle(operator)
          const text = `'${dateFilter.text}' ${operatorName} '${value}'`

          const newFilter = {
            field,
            operator,
            value,
            text,
            disabled: false
          }

          newFilters.push(newFilter)

          return
        }

        const value = this.advancedFilters[key]

        if (value === null || value === undefined) {
          return
        }
  
        if ((filter.type === 'string' || filter.type === 'number') && value === '') {
          return
        }

        const operator = this.advancedFieldOperators[key]
        const operatorName = getOperatorTitle(operator)
        const text = `'${filter.text}' ${operatorName} '${value}'`

        const newFilter = {
          field: key,
          operator,
          value,
          text,
          disabled: false
        }

        newFilters.push(newFilter)
      })
      this.addFilterSet(newFilters)
    },
    resetAdvancedFilters() {
      this.advancedFilters = {}
      this.setAdvancedFieldOperators
    },
    resetList() {
      this.activeFilters = []
      this.visibleColumns = this.defaultColumns
      // this.options.sortBy = null
      this.options = { ...this.options, itemsPerPage: 10, page: 1 }

      // this.updateResults()
      this.unsetSetting()
    },
    addFilter(filter) {
      this.activeFilters.push(filter)
      this.activeFavouriteId = null

      this.updateResults()
      this.unsetFavourite()
      this.setSetting()
    },
    addFilterSet(filters) {
      this.activeFilters.push(...filters)
      this.activeFavouriteId = null

      this.updateResults()
      this.unsetFavourite()
      this.setSetting()
    },
    removeFilter(filter) {
      this.activeFilters = this.activeFilters.filter(f => f.value !== filter.value)
      this.activeFilters = [...this.activeFilters]

      this.updateResults()
      this.unsetFavourite()
      this.setSetting()
    },
    newVisible(columns) {
      this.visibleColumns = columns
      this.unsetFavourite()
      this.setSetting()
    },
    configureSettings(setting) {
      this.configuring = true
      try {
        this.visibleColumns = setting.columns

        this.activeFilters = setting.filters
        this.options.sortBy = [setting.sortByField]
        this.options.sortDesc = [setting.sortByOrder === 'DESC']
        this.options.itemsPerPage = setting.itemsPerPage || 10
        this.options.page = setting.page || 1
      } catch (err) {
        this.unsetSetting()
      }
      this.configuring = false
    },
    setFavourite(id) {
      const favouriteSettings = this.favourites.find(f => f.id === id)
      this.configureSettings(favouriteSettings)
      this.setSetting()
      FavouritesManager.setFavouriteId(this.favouritesKey, id)
    },
    unsetFavourite() {
      FavouritesManager.unsetFavouriteId(this.favouritesKey)
      this.activeFavouriteId = null
    },
    setSetting() {
      FavouritesManager.setSetting(this.favouritesKey, {
        sortByField: this.options.sortBy[0],
        sortByOrder: this.options.sortDesc[0] ? 'DESC' : 'ASC',
        columns: this.visibleColumns,
        filters: this.activeFilters,
        itemsPerPage: this.options.itemsPerPage,
        page: this.options.page
      })
    },
    unsetSetting() {
      this.configuring = true
      this.unsetFavourite()
      FavouritesManager.unsetSetting(this.favouritesKey)
      this.configuring = false
    },
    configureFavourites() {
      this.favourites = []
      this.visibleColumns = this.defaultColumns
      this.isReady = true
      const existingSetting = FavouritesManager.checkSetting(this.favouritesKey)
      if (existingSetting) {
        this.configureSettings(existingSetting)
      } else {
        this.visibleColumns = this.defaultColumns
        this.options.sortBy = ['id']
        this.options.sortDesc = 'DESC'
      }
    },
    updateResults() {
      this.loading = true
      this.selected = []
      this.getData().then((data) => {
        this.listData = data.items
        this.total = data.total
        this.loading = false
        this.setSetting()
        setTimeout(() => {
          this.$refs.bottomButton.handleScroll()
        }, 10)
      })
    },
    getData() {
      const route = `${this.apiRoute}?${generateParams(this.options, this.activeFilters, this.queryParams, this.searchText)}`
      return axios.get(route).then((response) => {
        return { items: response.data.result, total: response.data.total }
      })
    },
    saveFavourite() {
      const data = {
        rowsPerPage: this.options.itemsPerPage,
        sortByField: this.options.sortBy[0],
        sortByOrder: this.options.sortDesc === [true] ? 'DESC' : 'ASC',
        title: this.newFavouriteName,
        columns: this.visibleColumns,
        filters: this.activeFilters
      }

      axios.post(`favourites/${this.favouritesKey}`, data).then((response) => {
        const newFavourite = response.data
        this.favourites.push(newFavourite)
        this.activeFavouriteId = newFavourite.id
        this.setFavourite(newFavourite.id)
        this.newFavouriteName = null
        this.saveFavouriteDialog = false
        this.saveFavouriteError = null
      }).catch((err) => {
        this.saveFavouriteError = err.response.data
      })
    },
    renderValue(item, column) {
      const displayFn = this.displayFunctions[column]

      if (displayFn) {
        return displayFn(item[column])
      }
      if (item[column] === null) {
        return '-'
      }
      return item[column]
    },
    toggleFilter(filter) {
      filter.disabled = !filter.disabled
      this.activeFilters = [...this.activeFilters]
      this.updateResults()
    },
    applySearch() {
      this.updateResults()
    },
    validActions(item) {
      return this.actions.filter(action => !action.visible || action.visible(item))
    },
    exportList() {
      this.exportModal = true
    },
    download(includePagination) {
      this.exportModal = false
      const paramString = generateParams(this.options, this.activeFilters, this.queryParams, this.searchText, !includePagination)
      this.downloadFile(paramString)
    },
    saveFile(data) {
      const blob = new Blob([data])
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `${this.exportName}.xlsx`
      link.click()
    },
    async downloadFile(paramString) {
      try {
        const response = await axios.get(`${this.apiRoute}/export?${paramString}`, { responseType: 'arraybuffer' })
        this.saveFile(response.data)
      } catch {
        this.$store.dispatch('showError', 'Error downloading certification')
      }
    },
    doBulkAction() {
      if (this.selectedBulkAction) {
        this.selectedBulkAction(this.selected)
      }
    },
    getOperators(type) {
      if (type === 'string') {
        return stringOperators
      } else if (type === 'number') {
        return operators
      } else if (type === 'enum' || type === 'boolean') {
        return enumOperators
      }
    },
    getOperatorTitle(key) {
      return getOperatorTitle(key)
    }
  }
}

function generateParams(pagination, filters, extraParams, searchText, ignoreOffset = false) {
  let paramString = ignoreOffset ? 'offset=0' : `count=${pagination.itemsPerPage}&offset=${(pagination.page - 1) * pagination.itemsPerPage}`

  if (pagination.sortBy) {
    paramString += `&orderBy[${pagination.sortDesc[0] ? 'DESC' : 'ASC'}]=${pagination.sortBy}`
  }

  paramString = filters.reduce((current, filter) => {
    return filter.disabled ? current : current + `&${filter.field}[${filter.operator}]=${encodeURI(filter.value)}`
  }, paramString)

  paramString += '&' + extraParams.join('&')

  paramString += `search=${encodeURIComponent(searchText)}`

  return paramString
}

export function getValidOperators(type) {
  return type === 'string' ? stringOperators : type === 'enum' ? enumOperators : operators
}

export function getOperatorTitle(key) {
  if (!key) return
  return operators.find(o => o.key === key).text
}

const operators = [
  { text: 'Equals', key: 'eq' },
  { text: 'Not Equals', key: 'ne' },
  { text: 'Contains', key: 'lk' },
  { text: 'Greater than', key: 'gt' },
  { text: 'Greater than or equal to', key: 'gte' },
  { text: 'Less than', key: 'lt' },
  { text: 'Less than or equal to', key: 'lte' }
]

const stringOperators = [
  { text: 'Equals', key: 'eq' },
  { text: 'Not Equals', key: 'ne' },
  { text: 'Contains', key: 'lk' }
]

const enumOperators = [
  { text: 'Equals', key: 'eq' },
  { text: 'Not Equals', key: 'ne' }
]

</script>
<style>
  /* FIXME - Temporary style until PR with dense fields is approved: https://github.com/vuetifyjs/vuetify/pull/8810 */
  .search-input .v-input__control .v-input__slot .v-text-field__slot input {
    padding: 0;
  }

  .search-input .v-input__control .v-input__slot .v-text-field__slot label {
    top: 8px !important;
  }

  .search-input .v-input__control .v-input__slot {
    min-height: 36px;
  }
</style>

<style>
.selected-row {
  background-color: #f5f5f5;
}
</style>